import { notify } from 'reapop'
import { smsLogsConstants } from '../constants'
import { smsLogsService } from '../services'

export const smsLogsAction = {
    getSmsLogData
}

function getSmsLogData(data) {
    return dispatch => {
        dispatch(request())

        smsLogsService.getSmsLogsData(data)
            .then(
                verified => dispatch(success(verified)),
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(notify({ position: "tc", dismissible: false, message: error.toString(), status: "error" }))
                }
            )
    }

    function request() { return { type: smsLogsConstants.GET_SMS_LOG_DATA_REQUEST } }
    function success(result) { return { type: smsLogsConstants.GET_SMS_LOG_DATA_SUCCESS, result } }
    function failure(error) { return { type: smsLogsConstants.GET_SMS_LOG_DATA_FAILURE, error } }
}
